// 숫자 옵션은 숫자로 저장한다. 글자("10")로 저장되면 에이전트가 숫자 비교에서 오류를 냈다(2026-10-17 현장).
const NUMERIC_OPTION_KEYS = ['pollStateSec', 'pollCounterSec', 'pollSec'];
export const normalizeOptions = (options) => {
  const out = { ...(options || {}) };
  NUMERIC_OPTION_KEYS.forEach((k) => {
    if (out[k] === '' || out[k] === null || out[k] === undefined) {
      delete out[k];
    } else if (!Number.isNaN(Number(out[k]))) {
      out[k] = Number(out[k]);
    }
  });
  return out;
};
